import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { paths } from '@platform/paths';
import {
  ADD_NEW_PROPERTY_PAGE_ID,
  PortfolioCarouselComponentStore,
} from '@platform/portfolio/pages/portfolio-carousel/portfolio-carousel.store';
import { ModalContainerComponent } from '@shared-lib/components/modal-container/modal-container.component';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PaginatorModule } from 'primeng/paginator';

export interface AddMortgageSuggestionDialogData {
  propertyName: string;
  propertyId: string;
}

@Component({
  selector: 'cp-add-mortgage-suggestion-dialog',
  imports: [ButtonDirective, ModalContainerComponent, PaginatorModule],
  templateUrl: './add-mortgage-suggestion-dialog.component.html',
  styleUrl: './add-mortgage-suggestion-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddMortgageSuggestionDialogComponent implements AfterViewInit {
  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly router = inject(Router);
  private readonly portfolioComponentStore = inject(PortfolioCarouselComponentStore);
  protected readonly dynamicDialogConfig: DynamicDialogConfig<AddMortgageSuggestionDialogData> = inject(DynamicDialogConfig);

  protected isDialogPositionUp = false;

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.isDialogPositionUp = true;
      this.changeDetectorRef.markForCheck();
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  addMortgage(): void {
    void this.router.navigate(['/', paths.PLATFORM, paths.platform.MORTGAGES, paths.platform.mortgages.ADD], {
      queryParams: {
        propertyId: this.dynamicDialogConfig.data.propertyId,
      },
    });
    this.close();
  }

  addNextProperty(): void {
    this.portfolioComponentStore.redirectToProperty({ propertyId: ADD_NEW_PROPERTY_PAGE_ID });
    this.close();
  }
}
